module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide-chat"
    }
  }, [_c('div', {
    staticClass: "viewContainer"
  }, [(!_vm.$store.getters.isWaitingInteraction) ? _c('div', {
    staticClass: "chatHolder",
    class: {
      'show-chat': _vm.$store.getters.isStartedInteraction
    }
  }, [_c('div', {
    staticClass: "accionIconos"
  }, [_c('chat-toolbar', {
    staticClass: "width-100",
    attrs: {
      "hideEndConv": this.endConv,
      "isBot": this.bot
    },
    on: {
      "openConfirmationModal": _vm.openCloseDialog,
      "clickCallEv": _vm.openWindowCalling,
      "clickVideoCallEv": _vm.openWindowVideocalling
    }
  })], 1), _vm._v(" "), _c('call', {
    ref: "callComponent",
    attrs: {
      "show": _vm.isInCall,
      "video": _vm.isOnVideoCall
    },
    on: {
      "hangupEv": _vm.hangup,
      "hideTextAreaEv": _vm.switchShowTextInput,
      "phone": _vm.onPhone
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showWebrtcStream.visible),
      expression: "showWebrtcStream.visible"
    }],
    attrs: {
      "id": "streamContainer"
    }
  }, [_c('v-btn', {
    class: {
      'oncall': _vm.isInCall
    },
    attrs: {
      "id": "closeStream",
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.screenShareController.closeStream()
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), _c('video', {
    class: {
      'oncall': _vm.isInCall
    },
    attrs: {
      "autoplay": "",
      "id": "webrtcstream",
      "width": "300px",
      "height": "300px"
    },
    domProps: {
      "srcObject": _vm.showWebrtcStream.stream
    }
  })], 1), _vm._v(" "), _c('closing-dialog', {
    attrs: {
      "messageDialogue": _vm.$t('closeconf'),
      "show": _vm.showClosingDialog
    },
    on: {
      "confirmClosingEv": _vm.shouldClose,
      "cancelClosingEv": _vm.hideClosingModal
    }
  }), _vm._v(" "), _c('screen-share-dialog', {
    attrs: {
      "show": _vm.showWebrtcStream.dialog
    },
    on: {
      "yes": function($event) {
        return _vm.screenShareController.shareScreen()
      },
      "no": function($event) {
        return _vm.screenShareController.cancelShareScreen()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "holderChat chat-background",
    class: {
      'relative-pos': this.$store.state.isLowRes, 'holderChatWithVideo': _vm.isOnVideoCall
    },
    style: ({
      'background-image': 'url(' + _vm.background + ')'
    })
  }, [_c('ol', {
    ref: "olchat",
    staticClass: "chat",
    class: _vm.isOnVideoCall ? 'chatWithVideo' : '',
    on: {
      "click": function($event) {
        return _vm.$refs.textarea.blur()
      }
    }
  }, [_vm._l((_vm.$store.state.interaction.messages), function(item, index) {
    return _c('message', {
      key: index,
      attrs: {
        "visible": !(index == 0 && _vm.hasParameters()),
        "message": item
      },
      on: {
        "menuMessage": _vm.menuMessageEvent
      }
    })
  }), _vm._v(" "), (_vm.typingVisible) ? _c('message') : _vm._e()], 2), _vm._v(" "), _c('closing-dialog', {
    attrs: {
      "messageDialogue": _vm.$t('conversationend'),
      "show": _vm.showEndConv
    },
    on: {
      "confirmClosingEv": _vm.acceptModalEndConv,
      "cancelClosingEv": _vm.cancelModalEndConv
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTextInput && !this.endConv && !_vm.$store.state.interaction.transfering),
      expression: "showTextInput && !this.endConv && !$store.state.interaction.transfering"
    }],
    staticClass: "containerButtons"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.typingText),
      expression: "typingText"
    }],
    ref: "textarea",
    staticClass: "textarea",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('typehere')
    },
    domProps: {
      "value": (_vm.typingText)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.sendMessage($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.typingText = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.$store.getters.hasTextareaText) ? _c('div', {
    staticClass: "btnTextarea"
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.sendMessage
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "grey darken-1"
    }
  }, [_vm._v("send")])], 1)], 1) : (this.$store.state.campaign.allow_attachments) ? _c('div', {
    staticClass: "btnTextarea"
  }, [(this.attachUploading) ? _c('v-btn', {
    attrs: {
      "icon": "",
      "disabled": ""
    }
  }, [_c('v-icon', {
    staticClass: "rotate"
  }, [_vm._v("autorenew")])], 1) : _c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addAttachment($event)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "grey darken-1"
    }
  }, [_vm._v("attach_file")])], 1), _vm._v(" "), _c('input', {
    ref: "inputfiles",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.onFileChange
    }
  })], 1) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.$store.getters.isWaitingInteraction) ? _c('v-card', {
    attrs: {
      "id": "holderWaiting"
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('div', {
    staticClass: "finishInteractionButton",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showModalAbandon = true
      }
    }
  }, [_c('v-icon', {
    style: ({
      'color': _vm.invertColor(this.$store.state.campaign.color)
    })
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('close')))])]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "290"
    },
    model: {
      value: (_vm.showModalAbandon),
      callback: function($$v) {
        _vm.showModalAbandon = $$v
      },
      expression: "showModalAbandon"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.$t('closeconf')))]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "flat": "flat"
    },
    on: {
      "click": function($event) {
        return _vm.clickModalAbandon()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('yes')))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "flat": "flat"
    },
    on: {
      "click": function($event) {
        _vm.showModalAbandon = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('no')))])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "holdTimeText"
  }, [_c('p', [_c('v-icon', {
    staticClass: "rotate"
  }, [_vm._v("autorenew")])], 1), _vm._v(" "), _c('p', [_vm._v("\n          " + _vm._s(_vm.$t('holdtime')) + "\n          "), _c('chronometer')], 1)])], 1) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21bb7960"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat.vue
// module id = 403
// module chunks = 2